import React from 'react'
// import PropTypes from 'prop-types'

export default class TextArea extends React.Component {
  static defaultProps = {
    maxRows: null,
    rows: null,
  }

  state = {
    height: 0,
  }

  registerRef = el => {
    this.el = el
  }

  getLineHeight = () => {
    const { maxRows, rows } = this.props
    const values = {}
    const textarea = document.createElement('textarea')
    textarea.style.padding = '0px'
    textarea.style.position = 'fixed'
    textarea.style.top = '-10000px'
    textarea.style.visibility = 'hidden'
    textarea.style.maxHeight = 'none'
    textarea.style.width = `${this.el.scrollWidth}px`
    textarea.className = this.el.className
    textarea.value = ' '
    textarea.rows = 1

    this.el.parentNode.insertBefore(textarea, this.el)
    const paddingAndBorder = textarea.offsetHeight - textarea.scrollHeight
    values.lineHeight = textarea.scrollHeight
    textarea.value = this.el.value
    textarea.rows = this.el.rows
    values.autoHeight = textarea.scrollHeight + paddingAndBorder
    textarea.remove()

    if (rows !== null || maxRows !== null) {
      if (rows !== null) {
        // box sizing is border-box
        values.minHeight = values.lineHeight * rows + paddingAndBorder
        values.autoHeight = Math.max(values.minHeight, values.autoHeight)
      }
      if (maxRows !== null) {
        // box sizing is border-box
        values.maxHeight = values.lineHeight * maxRows + paddingAndBorder
        values.autoHeight = Math.min(values.maxHeight, values.autoHeight)
      }
    }

    values.rowCount = Math.floor(values.autoHeight / values.lineHeight)

    return values
  }

  autoGrow = text => {
    const el = this.el
    if (!el) return
    const offset = !window.opera
      ? el.offsetHeight - el.clientHeight
      : el.offsetHeight +
        parseInt(window.getComputedStyle(el, null).getPropertyValue('border-top-width'), 10)
    el.style.height = 'auto'
    const height = Math.max(this.state.minHeight, el.scrollHeight + offset)
    if (this.state.maxHeight) {
      el.style.height = Math.min(this.state.maxHeight, height)
    } else {
      el.style.height = height + 'px'
    }
  }

  componentDidMount() {
    const sizes = this.getLineHeight()
    this.setState(sizes)
    setTimeout(this.autoGrow)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.autoGrow()
    }
  }

  render() {
    const { maxRows, rows, labelText, style, ...attributes } = this.props
    const styles = {
      height: this.state.autoHeight,
      ...style,
    }
    return (
      <textarea ref={this.registerRef} style={styles} onInput={this.autoGrow} {...attributes} />
    )
  }
}



// WEBPACK FOOTER //
// ./ui/Input/Textarea.js